import * as React from 'react';
import { Link } from '../Link/Link';
import { LinkVariant } from '../Link/LinkVariant.csharp';
import { AdditionalNotes } from '../LinkListSection/Components/AdditionalNotes/AdditionalNotes';
import { List } from '../List/List';
import styles from './LinkWithDescriptionListSection.module.css';
import type { LinkWithDescriptionListSectionProps } from './LinkWithDescriptionListSectionProps.csharp';

export const LinkWithDescriptionListSection: React.FC<
    React.PropsWithChildren<LinkWithDescriptionListSectionProps>
> = props => {
    const { title, items } = props;

    return (
        <div className={styles.LinkWithDescriptionListSection}>
            <div className={styles.Inner}>
                <div className={styles.Content}>
                    {title && <h2 className={styles.Title}>{title}</h2>}
                    <List
                        className={styles.List}
                        items={items}
                        renderItem={(item, index) => (
                            <li key={index} className={styles.ListItem}>
                                <div className={styles.ItemWrapper}>
                                    <Link
                                        {...item.link}
                                        variant={LinkVariant.Primary}
                                        showIsExternal={false}
                                        className={styles.Link}
                                    />
                                    <AdditionalNotes notes={item.additionalNotes} />
                                </div>
                                {item.description && (
                                    <div className={styles.DescriptionWrapper}>
                                        <p className={styles.Description}>{item.description}</p>
                                    </div>
                                )}
                            </li>
                        )}
                    />
                </div>
            </div>
        </div>
    );
};
